import { useEffect, useState } from "react";

export interface DisclosureItem {
  displayOrder: number;
  language: string;
}

export interface UseDisclosureResult {
  data: DisclosureItem[];
  error: Error | null;
  isLoading: boolean;
}

const useDisclosure = (pageName?: string): UseDisclosureResult => {
  const [data, setData] = useState<DisclosureItem[]>([]);
  const [error, setError] = useState<Error | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchDisclosures = async () => {
      setIsLoading(true);
      try {
        const url = pageName
          ? `/api/dice/user-management/us_en/disclosures?pageName=${encodeURIComponent(pageName)}`
          : "/api/dice/user-management/us_en/disclosures";
        const response = await fetch(
          url,
          {
            method: "GET",
            headers: {
              accept: "application/json",
            },
          },
        );

        if (!response.ok) {
          setError(new Error("Unable to fetch disclosures"));
          return;
        }

        const json = await response.json();
        const disclosures: DisclosureItem[] = [...json.disclosures].sort(
          (a: DisclosureItem, b: DisclosureItem) =>
            a.displayOrder - b.displayOrder,
        );

        setData(disclosures);
      } catch (e) {
        setError(e as Error);
        console.error("Error fetching disclosures: ", e);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDisclosures();
  }, [pageName]);

  return { data, error, isLoading };
};

export default useDisclosure;
